import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { FaHandshake, FaRegWindowClose } from "react-icons/fa";
import { MdCalendarViewMonth, MdIosShare, MdOutlineBallot, MdOutlineLabel, MdOutlineRemoveRedEye, MdOutlineSwapVert, MdOutlineToc, MdOutlineVerticalSplit, MdSubject } from "react-icons/md";
import { MdMoreHoriz } from "react-icons/md";
import { etherToGwei, fetchEthPriceToUSDT, getDataFromURI, getTransactionHistory } from "../../../hooks/Tokenhook";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { SlGraph } from "react-icons/sl";
import CollcetionItemCard from "../../../components/collection/CollectionItemCard";
import { GetView, IncreaseView } from "../../../hooks/MostViewHook";
import ether from "../../../assets/img/icons/ether.png";
import ipfsImg from "../../../assets/img/icons/ipfs.jpg";
import { Modal } from "react-bootstrap";
import { convertEpochToDateTime, GetAllOpenAuction, GetAuctionDetails, GetAuctionList, RaiseBidOfAuction, WithdrawBidOfAuction } from "../../../hooks/AuctionHook";
import { getUserByAddress } from "../../../hooks/User";
import { getCollectionDetails, getHashFromCollection, getURIFromCollection } from "../../../hooks/Collectionhook";
import { useSelector } from 'react-redux';
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import itemLogo from "../../../assets/img/items/item_1.png";
import BidderList from "../NftPages/BidderList";
import ReactTooltip, { Tooltip } from "react-tooltip";
import { likeNFT, listNFTs } from "../../../hooks/NFTHook";
import { FaArrowUpLong, FaHeart, FaRegHeart } from "react-icons/fa6";

export const AuctionDetails = () => {
    const { collectionAddress, auctionId } = useParams();
    const userId = localStorage.getItem("userId");
    const walletAddress = localStorage.getItem("WalletAddress");
    const [nft, setNft] = useState(null);
    const [updateIp, setUpdateIp] = useState(0);
    const [isCopied, setIsCopied] = useState(false);
    const [properties, setProperties] = useState([]);
    const [openPanel, setOpenPanel] = useState('description');
    const [openPanel1, setOpenPanel1] = useState("details");
    const [user, setUser] = useState(null);
    const [updateBid, setUpdateBid] = useState(false);
    const [ipfs, setIpfs] = useState(null);
    const [hash, setHash] = useState(null);
    const [history, setHistory] = useState([]);
    const [viewsCount, setViewCount] = useState(0);
    const [collectionDetails, setCollectionDetails] = useState();
    const [modalIsOpen, setIsOpen] = useState(false);
    const [price, setPrice] = useState(0);
    const PROVIDER = useSelector((state) => state.valueFromHeader);
    const [selfPreviousBid, setSelfPreviousBid] = useState(null);
    const [bidbuttonToggle, setBidbuttonToggle] = useState(false);
    const [checkSelf, setCheckself] = useState(false);
    const [checkSelfBid, setCheckselfBid] = useState("");
    const [userReqAmount, setUserReqAmount] = useState(null);
    const [error, setError] = useState("");
    const userIds = localStorage.getItem("userId");
    const [auctionBidHistory, setAuctionBidHistory] = useState([]);

    function openModal() {
        setIsOpen(true);
    }

    function closeModal() {
        setIsOpen(false);
    }

    const onCopyText = () => {
        setIsCopied(true);
        setTimeout(() => {
            setIsCopied(false);
        }, 1000);
    };

    useEffect(() => {
        // AuctionData()
        GetAuctions()
        // TransactionHistory()

    }, [updateBid])


    const GetAuctions = async () => {
        try {
            const { success, data, total, totalPages, page } = await GetAuctionDetails(auctionId);
            if (!success) return;
    
            console.log("AuctionListActive", data, total, totalPages, page);
    
            // Fetch market data
            const marketData = await fetchMarketData(data);
            const MarketNFTs = marketData.data;
    
            // Process market NFTs
            const updatedMarketNFTs = await Promise.all(
                MarketNFTs.map(async (item) => {
                    const isLike = item.likes.some(like => like.userId === userIds);
    
                    // Fetch user details for activity
                    const updatedActivity = await Promise.all(
                        item.activity.map(async (activity) => {
                            try {
                                const fromUserData = await getUserByAddress(activity.from);
                                const toUserData = await getUserByAddress(activity.to);
    
                                return {
                                    ...activity,
                                    fromUser: fromUserData?.user || null,
                                    toUser: toUserData?.user || null,
                                };
                            } catch (error) {
                                console.error("Error fetching user data for activity:", error);
                                return activity;
                            }
                        })
                    );
    
                    return { ...item, isLike, activity: updatedActivity.reverse() };
                })
            );
    
            const getEndTime = convertEpochToDateTime(data.endTime);
    
            // Fetch bid history
            let bidHistory = null;
            try {
                const auctionDetails = await GetAuctionDetails(auctionId);
                if (auctionDetails.status === 200) {
                    const BidData = auctionDetails.data;
                    const BidHistory = BidData.bidHistory || [];
    
                    if (BidHistory.length > 0) {
                        const updatedBidHistory = await Promise.all(
                            BidHistory.map(async (bid) => {
                                try {
                                    const userData = await getUserByAddress(bid.bidder);
                                    const ethPriceUSD = await fetchEthPriceToUSDT(bid.amount);
    
                                    return {
                                        ...bid,
                                        userData: userData.status === 200 ? userData.user : bid.bidder,
                                        usdAmount: ethPriceUSD,
                                    };
                                } catch (error) {
                                    console.error("Error fetching bid user data:", error);
                                    return { ...bid, usdAmount: await fetchEthPriceToUSDT(bid.amount) };
                                }
                            })
                        );
    
                        // Get latest highest bid
                        const latestBid = updatedBidHistory.reduce((highest, bid) =>
                            parseFloat(bid.amount) > parseFloat(highest.amount) ? bid : highest
                        );
    
                        setUserReqAmount(latestBid);
    
                        const reversedBids = [...updatedBidHistory].reverse();
                        setAuctionBidHistory(reversedBids);
    
                        // Check if the current user has bids
                        const userBids = reversedBids.filter(bid => bid.bidder === walletAddress);
                        if (userBids.length > 0) {
                            const latestUserBid = userBids.sort((a, b) => parseFloat(b.usdAmount) - parseFloat(a.usdAmount))[0];
                            setCheckself(true);
                            setCheckselfBid(latestUserBid);
                            console.log("Latest User Bid", latestUserBid);
                        }
    
                        // Get highest bidder details
                        const highestBidder = await getUserByAddress(BidData.highestBidder);
                        const ethPriceUSD = await fetchEthPriceToUSDT(BidData.highestBid);
    
                        bidHistory = {
                            ...BidData,
                            highestBidderName: highestBidder.status === 200 ? highestBidder.user.name : null,
                            usdAmount: ethPriceUSD,
                            bidHistory: reversedBids,
                        };
                    }
                }
            } catch (error) {
                console.error("Error fetching bid history:", error);
            }
    
            // Merge market data and auction details
            const collectionsWithMarketData = {
                ...data,
                bidHistory,
                ...(updatedMarketNFTs.length > 0 ? updatedMarketNFTs[0] : {}),
            };
    
            console.log("Final Collection Data", collectionsWithMarketData);
            setNft(collectionsWithMarketData);
        } catch (error) {
            console.error("Error in GetAuctions:", error);
        }
    };
    
    const fetchMarketData = async (data) => {
        try {
            const params = {
                tokenId: data.tokenId,
                contractAddress: data.collectionAddress,
            };
            const response = await listNFTs(params);
            console.log("response", response, params);

            return response.success ? response : { success: false, data: [] };
        } catch (error) {
            console.error("Error fetching market data:", error);
            return { success: false, data: [] };
        }
    };

    const togglePanel = (panelId) => {
        setOpenPanel(openPanel === panelId ? '' : panelId);
    };

    const getIncrementedMaxPrice = (highestBid, userReqAmount) => {
        let result;
        if (userReqAmount !== null) {
            result = highestBid - userReqAmount.amount;
            console.log("result", result);
        }
        else {
            result = 0
        }
        return parseFloat((result + 0.000001).toFixed(6));
    };

    const maxPrice =
        getIncrementedMaxPrice(nft?.bidHistory?.highestBid, userReqAmount)
    // parseFloat((userReqAmount !== null ? parseFloat((nft?.bidHistory?.highestBid - userReqAmount?.amount)?.toFixed(6)) : 0 )+ 0.000001).toFixed(6);
    console.log("maxPrice", nft?.bidHistory?.highestBid, userReqAmount, maxPrice, typeof (price), price, price >= maxPrice);

    const handlePriceChange = (e) => {
        const value = parseFloat(e.target.value);

        if (value < maxPrice) {
            setError(`Price must not exceed ${maxPrice}`);
        } else {
            setError(""); // Clear error if input is valid
            setPrice(value);
        }
    };

    const handleError = (event) => {
        event.target.src = itemLogo;
    };

    const BidNFTAuction = async () => {
        const NewPrice = JSON.stringify(price);
        const UpdatedPrice = etherToGwei(price).toString();
        console.log("New Price", NewPrice, UpdatedPrice, nft);

        await RaiseBidOfAuction(auctionId, NewPrice).then(async (data) => {
            const BidData = data.data;
            console.log("BidData", BidData);

            const signer = await PROVIDER.getSigner(walletAddress);
            const sentTx = await signer.sendTransaction(BidData);
            const receipt = await sentTx.wait();
            if (receipt) {
                toast.success("Bid successful");
                setUpdateBid(true)
                closeModal()
            }
        })
    }

    const EndNFTAuction = async () => {
        const auctionId = nft.auctionId;
        const UpdatedPrice = etherToGwei(price);
        await RaiseBidOfAuction(auctionId, price).then(async (data) => {
            const BidData = data.data;
            const signer = await PROVIDER.getSigner(walletAddress);
            const sentTx = await signer.sendTransaction(BidData);
            const receipt = await sentTx.wait();
            if (receipt) {
                console.log("Transaction successful:", receipt);

            }
        })
    }

    const WithdrawNFTAuction = async () => {
        const auctionId = nft.auctionId;
        const UpdatedPrice = etherToGwei(price);
        await WithdrawBidOfAuction(auctionId).then(async (data) => {
            const BidData = data.data;
            const signer = await PROVIDER.getSigner(walletAddress);
            const sentTx = await signer.sendTransaction(BidData);
            const receipt = await sentTx.wait();
            if (receipt) {
                console.log("Transaction successful:", receipt);

            }
        })
    }
    const EpochToDateTime = ({ epochTime }) => {
        // Function to convert epoch time to human-readable format

        return (
            <div>
                <p> Sale ends {convertEpochToDateTime(epochTime)}</p>
            </div>
        );
    }

    const CountdownTimer = ({ targetEpoch }) => {
        const calculateTimeLeft = () => {
            const difference = targetEpoch * 1000 - Date.now();
            let timeLeft = {};

            if (difference > 0) {
                timeLeft = {
                    days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                    hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                    minutes: Math.floor((difference / 1000 / 60) % 60),
                    seconds: Math.floor((difference / 1000) % 60)
                };
            }
            return timeLeft;
        };

        const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

        useEffect(() => {
            const timer = setTimeout(() => {
                if (calculateTimeLeft().seconds !== undefined) {
                    setBidbuttonToggle(true);
                }
                setTimeLeft(calculateTimeLeft());
            }, 1000);

            return () => clearTimeout(timer);
        });


        return (
            <div>
                {timeLeft.days !== undefined ? (
                    <div className="d-flex">
                        <div className="mr-5">
                            <h4 className="text-center">{timeLeft.days}</h4>
                            <p>Days</p>
                        </div>
                        <div>
                            <h4 className="text-center">{timeLeft.hours}</h4>
                            <p>Hours</p>
                        </div>
                        <div className="mx-5">
                            <h4 className="text-center">{timeLeft.minutes}</h4>
                            <p>Minutes</p>
                        </div>
                        <div>
                            <h4 className="text-center">{timeLeft.seconds}</h4>
                            <p>Seconds</p>
                        </div>
                    </div>
                ) : (
                    <p>Time's up!</p>
                )}
            </div>
        );
    };
    function getTimeDifference(timestamp) {
        const now = new Date();
        const past = new Date(timestamp);
        const diffInSeconds = Math.floor((now - past) / 1000);

        const units = [
            { label: "y", seconds: 31536000 },
            { label: "mo", seconds: 2592000 },
            { label: "w", seconds: 604800 },
            { label: "d", seconds: 86400 },
            { label: "h", seconds: 3600 },
            { label: "m", seconds: 60 },
            { label: "s", seconds: 1 }
        ];

        for (const unit of units) {
            const value = Math.floor(diffInSeconds / unit.seconds);
            if (value >= 1) {
                return `${value} ${unit.label}${value > 1 ? '' : ''} ago`;
            }
        }

        return "Just now";
    }
    const handleLikeNFT = (e) => {
        console.log("handleLike triggered"); // Debug log
        e.stopPropagation();

        if (!nft.userId) {
            toast.dismiss();
            toast.error("Please login first!");
            return;
        }

        const body = { userId: userId };

        if (!nft.isLike) {
            console.log("Liking NFT"); // Debug log
            toast.dismiss();
            likeNFT(nft._i, body)
                .then((data) => {
                    if (data.success) {
                        setTimeout(() => {
                            toast.success("Liked Successfully!");
                            GetAuctions()
                        }, 2000);
                    }
                })
                .catch((error) => {
                    console.error("Error liking NFT:", error);
                    toast.error("Failed to like. Please try again.");
                });
        } else {
            console.log("Disliking NFT"); // Debug log
            toast.dismiss();
            likeNFT(nft._id, body)
                .then((data) => {
                    if (data.success) {
                        setTimeout(() => {
                            toast.success("Disliked Successfully!");
                            GetAuctions()
                        }, 2000);
                    }
                })
                .catch((error) => {
                    console.error("Error unliking NFT:", error);
                    toast.error("Failed to dislike. Please try again.");
                });
        }
    };
    console.log("nft", nft, history, collectionDetails, auctionBidHistory);

    return (
        <div>
            {/* <Header /> */}
            <div className="container">
                <Link to="/marketplace" className="btn btn-white btn-sm my-40">
                    back to home
                </Link>
                {nft !== null ?
                    <div className="nft_details">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="nft_img_card">
                                    <div className="nft_asset">
                                        {nft?.assetType?.split('/')[0] !== "image" ?
                                            <video
                                                autoPlay muted loop
                                                // autoPlay
                                                className="AssetMedia--video"
                                                // controls="false"
                                                controlsList="nodownload"
                                                // loop
                                                playsInline
                                                // poster="https://i.seadn.io/s/raw/files/9daca5412390b6adf065ae181d675215.jpg?w=500&auto=format"
                                                preload="metadata"
                                            >
                                                <source
                                                    data-testid="AssetMedia--video"
                                                    src={nft?.imageUri}
                                                    type="video/mp4"
                                                />
                                            </video>
                                            :
                                            <img src={nft?.imageUri} alt="NFT image" onError={handleError} />
                                        }
                                    </div>
                                </div>

                                <div className="panel-container_top mt-3">
                                    <div className="panel-header" onClick={() => togglePanel('description')}>
                                        <p><MdSubject size={21} /> Description</p>
                                        <span>{openPanel === 'description' ? <FiChevronUp size={21} /> : <FiChevronDown size={21} />}</span>
                                    </div>
                                    {openPanel === 'description' && (
                                        <div className="panel-body">
                                            <p>
                                                {nft?.description}
                                            </p>
                                            <p>
                                                By <Link to={`/otherProfile/${nft?.creator?.walletAddress}`}>{nft?.creator?.userId?.name}</Link>
                                            </p>
                                        </div>
                                    )}
                                </div>
                                {nft?.attributes?.length !== 0 &&
                                    <div className="panel-container_null">
                                        <div className="panel-header" onClick={() => togglePanel('traits')}>
                                            <p> <MdOutlineLabel size={21} /> Traits </p>
                                            <span>
                                                {openPanel === 'traits' ? <FiChevronUp size={21} /> : <FiChevronDown size={21} />}
                                            </span>
                                        </div>
                                        {openPanel === 'traits' && (
                                            <div className="panel-body">
                                                {nft?.attributes.map((item, index) => (
                                                    <div key={index}>
                                                        <div className="trait">
                                                            <span className="" style={{ textTransform: "capitalize" }}>{item.trait_type}</span>
                                                            <span>{item.value}</span>
                                                        </div>
                                                    </div>
                                                ))}

                                            </div>
                                        )}
                                    </div>
                                }
                                <div className="panel-container_bottom">
                                    <div className="panel-header" onClick={() => togglePanel('about')}>
                                        <p><MdOutlineVerticalSplit size={21} /> About {collectionDetails?.collectionDetails?.name ?? "DtoC"}  </p>
                                        <span>
                                            {openPanel === 'about' ? <FiChevronUp size={21} /> : <FiChevronDown size={21} />}
                                        </span>
                                    </div>
                                    {openPanel === 'about' && (
                                        <div className="panel-body">
                                            <p>
                                                {nft?.description}
                                            </p>
                                            {/* <span>
                                                Category: <strong>PFPs</strong>
                                            </span> */}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="nft_details_1 d-flex align-items-center justify-content-between">
                                    <h4>
                                        {collectionDetails?.collectionDetails?.name ?? "DtoC"}
                                    </h4>
                                    {/* <Link to='#'>
                                        <span>
                                            {nft.collectionName}
                                        </span>
                                    </Link> */}
                                    <div className="icons  d-flex align-items-center justify-content-between">
                                        <FaHandshake size={23} />
                                        <MdIosShare size={23} />
                                        <MdMoreHoriz size={23} />
                                    </div>
                                </div>
                                <div>
                                    <h2 style={{ textTransform: "capitalize" }}>
                                        {nft?.title}
                                    </h2>
                                    <p>
                                        own by <Link to={`/otherProfile/${nft?.currentOwner?.walletAddress}`} target="_blank">{nft?.currentOwner?.userId?.name}</Link>
                                    </p>
                                </div>
                                <div className="nft_details_2 my-10">
                                    <div className="nft_rank">
                                        <div className="mx-1">
                                            <MdOutlineRemoveRedEye />
                                        </div>
                                        <div>
                                            {nft?.totalViews}
                                            <span className="mx-2">
                                                views
                                            </span>
                                        </div>
                                    </div>
                                    <div className="nft_rank mx-2" onClick={(e) => handleLikeNFT(e)}>
                                        {nft?.isLike ?
                                            <>
                                                <FaHeart color="red" className="mx-2" />
                                            </>
                                            :
                                            <FaRegHeart className="mx-2" />
                                        }
                                        {` ${nft?.totalLikes}`} fav </div>
                                    {/* <div className="nft_rank">  PFPs(cat.) </div> */}

                                </div>
                                <div>
                                    <h6 className="my-10">
                                        View proof of authenticity
                                    </h6>
                                </div>
                                <div className="d-flex">
                                    <button
                                        className="btn btn-white btn-sm p4 mt-2 mr-2"
                                        type="button"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                    >
                                        <a
                                            href={nft?.tokenUri}
                                            target="_blank"
                                            rel="noreferrer"
                                            style={{ pointerEvents: true ? 'auto' : 'none' }}
                                        >
                                            <span className="p4 mx-2">
                                                <img src={ipfsImg} width="20" alt="" />

                                            </span>
                                            <span>
                                                {"View on IPFS"}

                                            </span>
                                        </a>
                                    </button>
                                    <button
                                        className="btn btn-white btn-sm p4 mt-2 mr-2"
                                        type="button"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                    >
                                        <a
                                            href={`https://sepolia.etherscan.io/tx/${nft?.transactionHash}`}
                                            target="_blank"
                                            rel="noreferrer"
                                            style={{ pointerEvents: true ? 'auto' : 'none' }}
                                        >
                                            <span className="p4 mx-2">
                                                <img src={ether} width="20" alt="" />
                                            </span>
                                            <span>
                                                {"View on Block Explorer"}

                                            </span>
                                        </a>
                                    </button>
                                </div>
                                <div className="panel-container mt-3">
                                    <div className="panel-body">
                                        <div>
                                            <EpochToDateTime epochTime={nft?.endTime} />
                                            <CountdownTimer targetEpoch={nft?.endTime} />
                                        </div>
                                        <hr />
                                        <div className="d-flex align-item-center justify-content-between">
                                            <div>
                                                <p>Highest Bid</p>
                                                <div className="d-flex">
                                                    {nft.bidHistory !== undefined ?

                                                        <>
                                                            <h3>
                                                                {nft?.bidHistory?.highestBid} ETH
                                                            </h3>

                                                            <span className="mx-2">$ {(nft?.bidHistory?.usdAmount)} </span>
                                                        </>
                                                        :
                                                        <h3>
                                                            N/A
                                                        </h3>}

                                                </div>
                                            </div>
                                            {nft?.bidHistory?.bidHistory?.length !== 0 &&
                                                <div>
                                                    <p>Highest Bidder Name</p>
                                                    <div className="d-flex">
                                                        <h3>
                                                            {nft?.bidHistory ? nft.bidHistory.highestBidderName : "N/A"}
                                                        </h3>
                                                        {/* <span className="mx-2">$ {nft.usdAmount !== NaN ? nft.usdAmount : 0} </span> */}
                                                    </div>
                                                </div>}
                                        </div>
                                        <div className="d-flex align-items-center mt-20">

                                            {
                                                bidbuttonToggle ?
                                                    <>
                                                        {nft?.bidHistory?.highestBidder === walletAddress ?
                                                            // true 
                                                            <a
                                                                data-tooltip-id="my-tooltip"
                                                                data-tooltip-content="Heigher bidder can't bid !"
                                                                data-tooltip-place="top"
                                                            >
                                                                <button className="btn btn-md btn-primary" disabled={true}>
                                                                    <nobr>
                                                                        Place A Bid
                                                                    </nobr>
                                                                </button>
                                                                <Tooltip id="my-tooltip" />
                                                            </a>
                                                            :
                                                            <button className="btn btn-md btn-primary" onClick={openModal}>
                                                                <nobr>
                                                                    Place A Bid
                                                                </nobr>

                                                            </button>
                                                        }
                                                    </>
                                                    :
                                                    <>
                                                        {nft?.seller === userId ?
                                                            <button className="btn btn-md btn-primary m-2" onClick={EndNFTAuction}>End Bid</button>
                                                            :
                                                            <button className="btn btn-md btn-primary  m-2" >Time's Up !!!</button>
                                                        }
                                                    </>
                                            }
                                            {nft?.bidHistory?.highestBidder === walletAddress ?
                                                // true 
                                                <a
                                                    data-tooltip-id="withdraw"
                                                    data-tooltip-content="Highest bidder can't bid !"
                                                    data-tooltip-place="top"
                                                >
                                                    <button className="btn btn-md btn-primary mx-3" disabled={true}>
                                                        <nobr>
                                                            Withdraw Bid
                                                        </nobr>

                                                    </button>
                                                    <Tooltip id="withdraw" />
                                                </a>
                                                :
                                                <button className="btn btn-md btn-primary mx-3" onClick={WithdrawNFTAuction}>
                                                    <nobr>
                                                        Withdraw Bid
                                                    </nobr>

                                                </button>
                                            }
                                        </div>
                                    </div>
                                    {/* )} */}
                                </div>
                                {history.length !== 0 &&
                                    <div className="panel-container mt-3">
                                        <div className="panel-header" onClick={() => togglePanel('history')}>
                                            <p> <SlGraph size="24" /> History</p>
                                            <span>{openPanel === 'history' ? <FiChevronUp size={21} /> : <FiChevronDown size={21} />}</span>
                                        </div>
                                        {openPanel === 'history' && (
                                            <div className="panel-body">
                                                <div className="trait">
                                                    {nft.bidHistory.map((item, index) => (
                                                        <div key={index}>
                                                            <div className="creator_item creator_card">
                                                                {Object.entries(item).map(([key, value]) => (
                                                                    <div key={key} className="d-flex">
                                                                        <div >
                                                                            <span>{key} : </span>
                                                                        </div>
                                                                        <div>
                                                                            <span> {value}</span>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    ))}

                                                </div>
                                            </div>
                                        )}
                                    </div>
                                }
                                <div className="panel-container">
                                    <div className="panel-header" onClick={() => setOpenPanel1("details")}>
                                        <p><MdOutlineBallot size={21} /> Details </p>
                                        <span>
                                            {openPanel1 === "details" ? <FiChevronUp size={21} /> : <FiChevronDown size={21} />}
                                        </span>
                                    </div>
                                    {openPanel1 === "details" && (
                                        <div className="panel-body">
                                            <div className="trait">
                                                <div>
                                                    Contract Address
                                                </div>
                                                <div>{nft?.collectionAddress?.slice(0, 10)}....{nft?.collectionAddress?.slice(-10)}</div>
                                            </div>
                                            <div className="trait">
                                                <div>
                                                    Token Id
                                                </div>
                                                <div>{nft?.tokenId}</div>
                                            </div>
                                            <div className="trait">
                                                <div>
                                                    Auction Id
                                                </div>
                                                <div>{auctionId}</div>
                                            </div>
                                            <div className="trait">
                                                <div>
                                                    Collection Name
                                                </div>
                                                <div>  {collectionDetails?.collectionDetails?.name ?? "DtoC"}</div>
                                            </div>
                                            <div className="trait">
                                                <div>
                                                    Token Standard
                                                </div>
                                                <div>ERC-721</div>
                                            </div>

                                        </div>
                                    )}
                                </div>
                                {auctionBidHistory.length !== 0 &&

                                    <div className="panel-container">
                                        <div className="panel-header" onClick={() => setOpenPanel1("offer")}>
                                            <p><MdOutlineToc size={21} /> Offer  </p>
                                            <span>
                                                {openPanel1 === "offer" ? <FiChevronUp size={21} /> : <FiChevronDown size={21} />}
                                            </span>
                                        </div>
                                        {openPanel1 === "offer" && (
                                            <div className="panel-body">
                                                <div className="trait">
                                                    <span>From</span>
                                                    <span>Price</span>


                                                </div>
                                                {/* {nft.bidHistory.map((data, i) => (<>
                                                    <div className="trait" key={i}>
                                                        <span>{data.amount} </span>
                                                        <span>{data.amount} ETH</span>

                                                    </div>
                                                </>))} */}
                                                <BidderList
                                                    bids={auctionBidHistory} />
                                            </div>
                                        )}

                                    </div>
                                }
                            </div>
                        </div>
                        {properties?.length !== 0 &&
                            <div className="panel-container mt-3">
                                <div className="panel-header" onClick={() => togglePanel('activity')}>
                                    <p> <MdOutlineSwapVert size={21} />  Item Activity</p>
                                    <span>{openPanel === 'activity' ? <FiChevronUp size={21} /> : <FiChevronDown size={21} />}</span>
                                </div>
                                {openPanel === 'activity' && (
                                    <div className="panel-body">

                                        {properties.map((item, index) => (
                                            <div key={index} style={{ marginBottom: "20px" }}>
                                                {Object.entries(item).map(([key, value], idx) => (
                                                    <p key={idx}>
                                                        <strong>{key}</strong>: {value}
                                                    </p>
                                                ))}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        }
                        {nft?.activity?.length !== 0 &&
                            <div className="panel-container mt-3">
                                <div className="panel-header" onClick={() => togglePanel('history')}>
                                    <p> <SlGraph size="24" /> Activity</p>
                                    <span>{openPanel === 'history' ? <FiChevronUp size={21} /> : <FiChevronDown size={21} />}</span>
                                </div>
                                {openPanel === 'history' && (
                                    <div className="panel-body">
                                        <div className="table-responsive mt-4">
                                            <table className="table table-hover activity-table">
                                                <thead>
                                                    <tr>
                                                        <th>Event</th>
                                                        <th>Price (ETH)</th>
                                                        <th>From</th>
                                                        <th>To</th>
                                                        <th>Date</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {nft.activity !== undefined && nft.activity.map((activity, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                <span className={`badge ${activity.event === 'Minted' ? "event-minted" : activity.event === 'Transferred' ? "event-transferred" : activity.event === 'Auctioned' ? "event-auctioned" : activity.event === 'Fractionalized' ? "event-fractionalized" : activity.event === 'Listed' ? 'event-listed' : activity.event === 'Traded' ? 'event-traded' : 'bg-info'}`}>
                                                                    {activity.event}
                                                                </span>
                                                            </td>
                                                            <td>{activity.price} ETH</td>
                                                            <td>
                                                                <Link to={activity.from === walletAddress ? "/profile" : `/otherProfile/${activity.from}`} className="text-truncate d-inline-block" style={{ maxWidth: '150px' }}>
                                                                    {activity.fromUser === null ? `${activity.from.slice(0, 6)}...${activity.from.slice(-4)}` : activity.fromUser.name}
                                                                </Link>
                                                            </td>
                                                            <td>
                                                                <Link to={activity.to === walletAddress ? "/profile" : `/otherProfile/${activity.to}`} className="text-truncate d-inline-block" style={{ maxWidth: '150px' }}>
                                                                    {activity.toUser === null ? `${activity.to.slice(0, 6)}...${activity.to.slice(-4)}` : activity.toUser.name}
                                                                </Link>
                                                            </td>
                                                            <td>
                                                                {getTimeDifference(activity.timestamp)} <FaArrowUpLong size={12} style={{ display: "inline-block", transform: "rotate(45deg)" }} />
                                                            </td>
                                                        </tr>
                                                        // );
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}
                            </div>
                        }
                        <div className="panel-container mt-3">
                            <div className="panel-header" onClick={() => togglePanel('collection')}>
                                <p> <MdCalendarViewMonth size={21} /> More From This Collection </p>
                                <span>
                                    {openPanel === 'collection' ? <FiChevronUp size={21} /> : <FiChevronDown size={21} />}
                                </span>
                            </div>
                            {openPanel === 'collection' && (
                                <div className="panel-body">
                                    <div className='py-4'>
                                        <CollcetionItemCard contractAddress={nft.collectionAddress} />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div> :
                    <h3>
                        Loading...
                    </h3>
                }
            </div>
            <Modal
                show={modalIsOpen}
                onRequestClose={closeModal}
                centered
                ariaHideApp={false}
                size="lg"
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <Modal.Header >
                    <Modal.Title id="example-modal-sizes-title-lg ">
                        {/* Large Modal */}
                        <div className='d-flex align-items-center justify-content-between'>
                            <h2>
                                Place a Bid for {nft && nft.title} NFT
                            </h2>

                        </div>
                    </Modal.Title>
                    <FaRegWindowClose onClick={closeModal} />
                </Modal.Header>
                <Modal.Body>
                    <div className="m-3 d-flex align-items-center justify-content-between">
                        <div className="m-3 d-flex align-items-center justify-content-between">

                            <div>
                                <img src={nft && nft.image} style={{ height: "5rem" }} className="rounded" alt="" />
                            </div>
                            <div className="mx-3">
                                <p className="fs-4">
                                    {nft && nft.title}
                                </p>
                                <p>
                                    {nft && nft.desc}
                                </p>


                            </div>
                        </div>
                        <div>
                            <h3>
                                {selfPreviousBid &&
                                    (checkSelf ? checkSelfBid.amount : "Not bid Yet")} ETH
                            </h3>
                            <span className="mx-2">{checkSelf}{`${selfPreviousBid ? selfPreviousBid.USDTPrice : 0} $`}</span>

                        </div>
                    </div>
                    {nft &&
                        <div style={{ backgroundColor: "#aba5a517" }} className="rounded-lg py-2">
                            <div className="m-3 d-flex align-items-center justify-content-between">
                                <h5 className="" style={{ whiteSpace: "nowrap" }}>
                                    Highest Bid
                                </h5>
                                <p className="" style={{ textAlign: "end" }}>
                                    {nft?.bidHistory?.highestBid} ETH
                                </p>
                            </div>

                        </div>
                    }
                    <div className="my-4">
                        <span className="fs-3 mx-2">
                            Price
                        </span>
                        <span >
                            ( Minimum required Amount for Bid :  {maxPrice} )
                        </span>
                        <input type="number" placeholder="Price" onChange={handlePriceChange} />
                        {error && <p style={{ color: "red" }}>{error}</p>}
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-sm btn-primary" onClick={closeModal}>No </button>
                    {price >= maxPrice ?
                        // <a
                        //     data-tooltip-id="my-tooltip"
                        //     data-tooltip-content="new Price will be greater then highest price !"
                        //     data-tooltip-place="top"
                        // >
                        <button className="btn btn-sm btn-primary"
                            onClick={() => BidNFTAuction()}
                        >Bid
                        </button>

                        //     <Tooltip id="my-tooltip" />
                        // </a>
                        :
                        <a
                            data-tooltip-id="my-tooltip"
                            data-tooltip-content="new Price will be greater then highest price !"
                            data-tooltip-place="top"
                        >
                            <button className="btn btn-md btn-primary" disabled={true}>
                                <nobr>
                                    Place A Bid
                                </nobr>

                            </button>
                            <Tooltip id="my-tooltip" />
                        </a>
                    }
                </Modal.Footer>

            </Modal>
            <ToastContainer position="bottom-right" />
        </div>
    );
};
